<template>
  <div class="customer">
    <div class="customer-group">
      <a-card :title="showTitle" :bordered="false" class="relative-doc-card" :loading="spinLoading">
        <div class="title-icon" slot="extra" v-if="canEdit">
          <a class="title-icon-item" href="#" @click="stop">
            <a-icon type="poweroff" />
            <span>{{status?"停用":"启用"}}</span>
          </a>
          <a class="title-icon-item" href="#" v-if="showChangName" @click="updateName()">
            <a-icon type="form" />
            <span>工商改名</span>
          </a>
        </div>
        <div class="customer-group-list">
          <div class="customer-group-list-item" v-for="(item, index) in initData" :key="item.label">
            <div class="customer-group-list-item-label">
              {{item.label}}
              <a class="title-icon-item" href="#" v-if="canEdit" @click="showModal(index, item.label)">
                <a-icon type="form" />
                <span>编辑</span>
              </a>
            </div>
            <div class="customer-group-list-item-content">
              <a-row>
                <a-col
                  :span="_item.tpl == 'textarea' ?24:8"
                  v-for="_item in item.fields"
                  :key="_item.field"
                >
                  <span class="label">{{_item.name}}：</span>
                  <span class="content">{{_item.value}}</span>
                </a-col>
              </a-row>
            </div>
          </div>
          <div class="customer-group-list-item" v-if="hasMember">
            <div class="customer-group-list-item-label">
              <span><span v-if="customer_type == 4">医疗</span>机构人员</span>
              <a class="title-icon-item" href="#" v-if="canEdit" @click="addMemberModal()">
                <a-icon type="plus" />
                <span>新增机构人员</span>
              </a>
            </div>
            <div class="customer-group-list-item-content">
              <a-table
                :indentSize="0"
                :locale="locale"
                :rowKey="record => record.key"
                :columns="memberColumns"
                :dataSource="memberSource"
                :loading="loading"
                :pagination="false"
              >
                <template slot="operation" slot-scope="text, record">
                  <span>
                    <a @click="edit(record)" v-if="canEdit">编辑</a>
                  </span>
                </template>
              </a-table>
            </div>
          </div>
          <div class="customer-group-list-item" v-if="dataSource && dataSource.length">
            <div class="customer-group-list-item-label">修改记录</div>
            <div class="customer-group-list-item-content">
              <a-table
                :indentSize="0"
                :locale="locale"
                :rowKey="record => record.key"
                :columns="columns"
                :dataSource="dataSource"
                :loading="loading"
                :pagination="false"
              ></a-table>
            </div>
          </div>
        </div>
        <bank-table-area class='mb8' v-if="id &&!hideBankAndCompany" :id="id" :canEdit="canEdit"></bank-table-area>
        <company-table-area v-if="id&&!hideBankAndCompany" :id="id" :canEdit="canEdit"></company-table-area>
      </a-card>
    </div>
    <cus-form-modal
      :visible="visible"
      :formModel="formModel"
      :confirmLoading="confirmLoading"
      :params="params"
      @on-change="onChange"
      @on-change2="onChange2"
      @on-search="onSearch"
      @on-save="onSave"
      @on-cancel="onCancel"
    ></cus-form-modal>
    <a-modal v-model="nameVisible" title="变更工商名称" ok-text="确认" cancel-text="取消" @ok="updateNameFn()">
      <div class="form-item">
        <span>变更工商名称</span>
        <a-input v-model="new_name" placeholder="请输入" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import cusService from "@/services/CustomerList.js";
import {BankTable,CompanyTable} from '@/components/detailTableArea';
import _ from "lodash";
export default {
  components:{BankTableArea:BankTable,CompanyTableArea:CompanyTable},
  computed:{
    hideBankAndCompany(){
      return [1,3].includes(this.customer_type*1)
    }
  },
  data() {
    return {
      breadcrumb: [
        {
          label: "客户管理",
          path: ""
        },
        {
          label: "客户信息",
          path: ""
        },
        {
          label: "客户详情",
          path: ""
        }
      ],
      status: false,
      canEdit: false,
      loading: false,
      spinLoading: true,
      customer_type: 1,
      initData: [],
      customer_info: "",
      change_record: "",
      showTitle: "",
      formModel: {
        title: "编辑",
        cancelText: "取消",
        okText: "确定",
        width: 640,
        formOptions: {
          hideRequiredMark: false
        },
        elements: []
      },
      memberModal: {
        title: "编辑",
        cancelText: "取消",
        okText: "确定",
        width: 640,
        formOptions: {
          hideRequiredMark: false
        },
        elements: [
          {
            type: "input",
            label: "姓名",
            options: [],
            key: "name",
            required: true,
            show: true
          },
          {
            type: "select",
            label: "角色",
            options: [],
            key: "role",
            required: false,
            show: true
          },
          {
            type: "select",
            label: "职务",
            options: [],
            key: "title",
            required: false,
            show: true
          },
          {
            type: "input",
            label: "Email",
            options: [],
            key: "email",
            required: false,
            show: true
          },
          {
            type: "input",
            label: "手机号",
            options: [],
            key: "phone",
            required: false,
            show: true
          }
        ]
      },
      visible: false,
      confirmLoading: false,
      params: {},
      loading: false,
      locale: {
        emptyText: "暂无数据"
      },
      columns: [
        {
          title: "曾用名",
          dataIndex: "name",
          key: "name",
          width: 450,
          align: "left"
        },
        {
          title: "修改人",
          dataIndex: "editor",
          key: "editor",
          width: 250,
          align: "left"
        },
        {
          title: "修改时间",
          dataIndex: "time",
          key: "time",
          width: 250,
          align: "left"
        }
      ],
      dataSource: [],
      memberColumns: [
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
          width: 250,
          align: "left"
        },
        {
          title: "角色",
          dataIndex: "role",
          key: "role",
          width: 250,
          align: "left"
        },
        {
          title: "职务",
          dataIndex: "title",
          key: "title",
          width: 250,
          align: "left"
        },
        {
          title: "Email",
          dataIndex: "email",
          key: "email",
          width: 250,
          align: "left"
        },
        {
          title: "手机号",
          dataIndex: "phone",
          key: "phone",
          width: 250,
          align: "left"
        },
        {
          title: "修改人",
          dataIndex: "operator",
          key: "operator",
          width: 250,
          align: "left"
        },
        {
          title: "修改时间",
          dataIndex: "update_time",
          key: "update_time",
          width: 350,
          align: "left"
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          width: 150,
          align: "left",
          scopedSlots: { customRender: "operation" }
        }
      ],
      memberSource: [],
      hasMember: false,
      memberStatus: "add",
      memberVisible: false,
      memberId: 0,
      nameVisible: false,
      new_name: "",
      showChangName: false,
      id:null
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.customer_type = this.$route.query.customerType;

    console.log(this.$route.query.canEdit*1);
    this.canEdit = !!(this.$route.query.canEdit*1) ;
    this.getDetail(this.$route.params.id);
    this.getBankList()//测试没参数记得改
    this.initMemberOptionsData();
  },
  methods: {
    getBankList(id=1){
cusService.getBankList(id).then(res => {
    if (res.status == "success" && res.data) {
      console.log(res);
    }
})
    },
    // get detail data
    getDetail(id) {
      cusService
        .getDetail({ id: id, customer_type: this.customer_type })
        .then(res => {
          if (res.status == "success" && res.data) {
            this.customer_info = res.data.customer_info;
            this.dataSource = res.data.change_record;
            this.status = res.data.customer_status;
            this.initOptionsData();
            let type = this.$route.query.customerType;
            if (type == 5) {
              this.showTitle =
                this.customer_info.group_customer_id.name +
                "-" +
                this.customer_info.customer_name;
            } else {
              this.showTitle = this.customer_info.customer_name;
            }
          }
        });
    },

    // init option data
    initOptionsData(customer_type = this.customer_type) {
      cusService.initOptionsData({ customer_type: customer_type }).then(res => {
        this.spinLoading = false;
        if (res.status == "success" && res.data && res.data.group.length) {
          this.initLabel = _.clone(res.data.group);
          this.handleData(this.initLabel, -1);
        }
        if (res.status == "success" && res.data && res.data.show_members) {
          this.hasMember = true;
          this.getMembersList();
        }
        if (res.status == "success" && res.data && res.data.show_chg_name) {
          this.showChangName = true;
        }
      });
    },

    // handle data
    handleData(dataArr, index) {
      let initArr = [],
        arr = [],
        d = "",
        typeArr = [],
        targetArr = [],
        obj = {},
        health_commission_hospital_name = "";
      if (index < 0) {
        initArr = dataArr;
      } else {
        initArr = [dataArr[index]];
      }
      initArr.forEach((element, index) => {
        if (index) {
          arr.push({
            type: "line",
            show: true
          });
        }
        element.fields.map((item, _index) => {
          d = this.customer_info[item.field];
          if (typeof d == "object") {
            console.log(d);
            console.log(item);
            item.value = d.name;
            if (item.tpl == "radio") {
              obj[item.field] = d.id;
            } else {
              if (item.field==='country') {
                obj[item.field] = d.id;
                
              } else {
                
                obj[item.field] = Number(d.id) || "";
              }
            }
          } else {
            item.value = d;
            obj[item.field] = d;
          }
          if (item.tpl == "text") {
            item.tpl = "input";
          }
          if (item.tpl == "select") {
            item.options &&
              item.options.length &&
              item.options.forEach(e => {
                e.target &&
                  e.target.length &&
                  e.target.forEach(_e => {
                    targetArr.push(_e);
                  });
              });
          }
          if (item.field == "individual_type") {
            typeArr = item.options;
          }
          if (item.field == "health_commission_hospital") {
            item.options = [
              {
                option_name: item.value,
                option_id: obj["health_commission_hospital"]
              }
            ];
          }
          arr.push({
            type: item.tpl,
            label: item.name,
            options: item.options || [],
            key: item.field,
            required: item.required,
            disabled: item.disabled,
            show: targetArr.includes(item.field) ? false : true
          });
        });
      });
      if (obj.hospitel_address) {
        obj.hospitel_address = obj.hospitel_address.split('/')
      }
      this.params = obj;
      this.formModel.elements = arr;
      this.initData = dataArr;
      if (this.customer_type == 6) {
        let key = [];
        typeArr.find(item => {
          if (item.option_id == this.params.individual_type) {
            key = item.target;
          }
        });
        if (key && key.length) {
          this.onChange(key);
        }
      }
    },

    // init member option data
    initMemberOptionsData() {
      cusService.initMemberOptionsData().then(res => {
        if (res.status == "success" && res.data.title) {
          res.data.title.forEach(item =>
            this.memberModal.elements[2].options.push({
              option_name: item.name,
              option_id: item.id
            })
          );
        }
        if (res.status == "success" && res.data.role) {
          res.data.role.forEach(item => {
            this.memberModal.elements[1].options.push({
              option_name: item.name,
              option_id: item.id
            });
          });
        }
      });
    },

    //enterprise modal confrim callback
    onSave(e) {
      let customer_info = _.clone(e)
      if (customer_info.hospitel_address) {
        customer_info.hospitel_address = customer_info.hospitel_address.join('/');
      }
      let params = {
        id: this.id,
        customer_type: this.customer_type,
        customer_info
      };
      if (this.memberVisible) {
        this.saveMember(e);
        return;
      }
      this.confirmLoading = true;
      cusService
        .modifyData(params)
        .then(res => {
          this.visible = false;
          if (res.status == "success") {
            this.$Message.success("修改成功！");
            this.getDetail(this.id);
          } else {
            this.$Message.error(res.message);
          }
          this.confirmLoading = false;
        })
        .catch(err => {
          this.visible = false;
          this.confirmLoading = false;
          this.$Message.error(err.message);
        });
    },

    // save member
    saveMember(e) {
      let params = {
        customer_id: this.id,
        ...e
      };
      if (this.memberStatus == "add") {
        delete params.member_id;
        cusService
          .addMember(params)
          .then(res => {
            this.visible = false;
            if (res.status == "success") {
              this.$Message.success("添加成功！");
              this.getMembersList();
            }
          })
          .catch(err => {
            this.visible = false;
            this.$Message.error(err.message);
          });
      } else {
        params.member_id = this.memberId;
        cusService
          .modifyMember(params)
          .then(res => {
            this.visible = false;
            if (res.status == "success") {
              this.$Message.success("修改成功！");
              this.getMembersList();
            }
          })
          .catch(err => {
            this.visible = false;
            this.$Message.error(err.message);
          });
      }
    },

    // modal camcel callback
    onCancel() {
      this.visible = false;
    },

    // get select change target
    onChange(show_key) {
      let targetArr = [];
      this.formModel.elements.map(item => {
        item.options &&
          item.options.length &&
          item.options.forEach(e => {
            e.target &&
              e.target.length &&
              e.target.forEach(_e => {
                targetArr.push(_e);
              });
          });
        if (targetArr.includes(item.key) && !show_key.includes(item.key)) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
      // console.log("联动处理数据", this.formModel.elements);
    },

    // get select change target and value
    onChange2(arr) {
      let target = arr[0],
        value = arr[1],
        arrs = [];
      this.formModel.elements.map(item => {
        if (item.key == target) {
          item.options.map(op => {
            if (op.parent_id === value) {
              op.hide = false;
            } else {
              op.hide = true;
            }
          });
        }
      });
    },

    // get search target and value
    onSearch(arr) {
      cusService.getHCHosp({ search_name: arr[0] }).then(res => {
        if (res.status == "success") {
          this.formModel.elements.map(item => {
            if (item.key == arr[1]) {
              item.options = [];
              res.data.forEach(element => {
                item.options.push({
                  option_name: element.name,
                  option_id: element.id
                });
              });
            }
          });
        }
      });
    },

    // stop it
    stop() {
      let vm = this;
      const modal = this.$Modal.confirm({
        title: `你确定${vm.status ? "停用" : "启用"}此客户吗？`,
        onOk() {
          let params = {
            id_list: [vm.id],
            customer_status: vm.status ? 0 : 1
          };
          cusService
            .changeState(params)
            .then(res => {
              if (res.status == "success") {
                vm.$Message.success("状态已变更");
                vm.$router.push({
                  name: "customer.list",
                  query: {
                    activeKey: vm.$route.query.activeKey
                  }
                });
              } else {
                vm.$Message.error(res.message);
              }
            })
            .catch(err => {
              vm.$Message.error(err.message);
            });
        },
        onCancel() {}
      });
    },

    // showModal
    showModal(i, name) {
      this.visible = true;
      this.memberVisible = false;
      this.formModel.title = "编辑-" + name;
      this.handleData(this.initLabel, i);
    },

    // get customer members list
    getMembersList() {
      cusService.getMemberList({ customer_id: this.id }).then(res => {
        if (res.status == "success") {
          this.memberSource = res.data;
        }
      });
    },

    // add member
    addMemberModal() {
      this.memberStatus = "add";
      this.visible = true;
      this.memberVisible = true;
      this.params = {};
      this.memberModal.title = "新增机构人员";
      this.formModel = this.memberModal;
    },

    // edit
    edit(record) {
      console.log(record);
      this.addMemberModal();
      this.memberStatus = "update";
      this.memberId = record.id;
      let obj = {};
      obj["name"] = record.name;
      obj["role"] = record.role;
      obj["title"] = record.title;
      obj["email"] = record.email;
      obj["phone"] = record.phone;
      // obj["country"] = record.country;
      this.params = obj;
      this.memberModal.title = "编辑机构人员";
      this.formModel = this.memberModal;
    },

    // change name
    updateName() {
      this.nameVisible = true;
    },

    // change name callback
    updateNameFn() {
      let params = { customer_id: this.id, new_name: this.new_name };
      cusService.changeName(params).then(res => {
        this.nameVisible = false;
        this.getDetail(this.id);
        if (res.status == "success") {
          this.$Message.success("变更成功!");
        } else {
          this.$Message.error(res.message);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.customer {
  margin: 16px;
  background-color: #fff;
  &-group {
    .title-icon {
      min-width: 150px;
      font-size: 14px;
      color: #1890ff;
      display: flex;
      justify-content: space-around;
      &-item {
        display: flex;
        align-items: center;
        margin-left: 10px;
        i {
          font-size: 13px;
          margin-top: 2px;
        }
        span {
          margin-left: 4px;
        }
      }
    }
    &-list {
      &-item {
        padding-bottom: 24px;
        margin-bottom: 24px;
        border-bottom: 1px solid #e8e8e8;
        &-label {
          font-size: 16px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 24px;
          display: flex;
          justify-content: space-between;
          a {
            font-size: 14px;
            font-weight: normal;
          }
        }
        &-content {
          line-height: 38px;
          .label {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
          }
          .content {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
          }
        }
        &:last-child {
          border: none;
        }
      }
    }
  }
}
.form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  span {
    display: inline-block;
    min-width: 100px;
  }
}
</style>